<template>
  <div>
    <div v-if="status == 1">
      <span class="badge bdg-new">Contacted</span>
    </div>
    <div v-if="status == 2">
      <span class="badge bdg-submitted">Converted</span>
    </div>
  </div>
</template>
  <script>
export default {
  name: 'WDQuoteStatusBadge',
  props: ['status']
}
</script>